import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import SwitchItem from "../SwitchItem";
import Datetime from "react-datetime";
import timezones from "../../../constants/timezones.json";
import {updateUserNotifications, userEdit} from "../../../actions/user";
import {week_days} from "../../../constants";

const CustomUserSettings = (props) => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const {profile} = user
    const {enable_language, language, languages, custom_week_start, week_start} = profile.attributes

    const handleLanguage = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("user[language]", e.target.value)
        dispatch(userEdit(formData))
    }

    const enableLanguage = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("user[enable_language]", e.target.checked)
        dispatch(userEdit(formData))
    }

    const handleSettings = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append(e.target.name, e.target.value)
        dispatch(userEdit(formData))
    }

    const enableSettings = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append(e.target.name, e.target.checked)
        dispatch(userEdit(formData))
    }

    return (
        <>
              <SwitchItem title="Custom translations"
                          desc="Choose the language you'd like to translate foreign comments to (our default is English)."
                          checked={enable_language ? true : false}
                          name="user[enable_language]"
                          changeHandler={enableSettings}>

                  {enable_language && <><div className="ml-4 mt-3 collapse show">
                  </div>
                      <div className="row languages-select mr-1">
                          <div className="col-lg-3">
                              <select className="form-select"
                                      name="user[language]"
                                      value={language}
                                      onChange={handleSettings}>
                                  {languages && languages.map((l, index) => {
                                      return <option key={index} value={l.code}>
                                          {l.name}
                                      </option>
                                  })}
                              </select>
                          </div>
                      </div>
                  </>}
              </SwitchItem>

            <SwitchItem title="Custom week start"
                        desc="Choose the day you'd like to start the week with in reporting and date pickers (our default is Sunday)."
                        checked={custom_week_start ? true : false}
                        name="user[custom_week_start]"
                        changeHandler={enableSettings}>

                {custom_week_start && <><div className="ml-4 mt-3 collapse show">
                </div>
                    <div className="row languages-select mr-1">
                        <div className="col-lg-3">
                            <select className="form-select"
                                    name="user[week_start]"
                                    value={week_start}
                                    onChange={handleSettings}>
                                {week_days && Object.entries(week_days).map(([k,v], index) => {
                                    return <option key={index} value={k}>
                                        {v}
                                    </option>
                                })}
                            </select>
                        </div>
                    </div>
                </>}
            </SwitchItem>
        </>
    )
}

export default React.memo(CustomUserSettings)
